var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStari = function SvgStari(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m13.289 3.46 1.577 5.167h5.284a1.367 1.367 0 0 1 .818 2.449l-4.332 3.35 1.619 5.3a1.352 1.352 0 0 1-2.106 1.487l-4.148-3.207-4.149 3.207a1.352 1.352 0 0 1-2.105-1.486l1.619-5.3-4.332-3.35a1.367 1.367 0 0 1 .818-2.45h5.284l1.576-5.162a1.344 1.344 0 0 1 2.577-.005",
    "data-name": "Path 5143"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStari);
export default ForwardRef;